module.exports = __webpack_public_path__ + "img/base-map-topographique.2965bf96.png";